import * as chat from './api/chat';
import * as service from './api/service';
import * as auth from './api/auth';
import * as user from './api/user';
import * as booking from './api/booking';

export const sportingAPI = { chat, service, auth, user, booking };
